import { render, staticRenderFns } from "./PaymentsView.vue?vue&type=template&id=2206f6fc&scoped=true"
import script from "./PaymentsView.vue?vue&type=script&lang=js"
export * from "./PaymentsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2206f6fc",
  null
  
)

export default component.exports